import CardMenu from "components/card/CardMenu";
import React from "react";
import Checkbox from "components/checkbox";
import { MdDragIndicator, MdCheckCircle } from "react-icons/md";
import Card from "components/card";

const TaskCard = () => {
  return (
    <Card extra="pb-7 p-[20px]">
      {/* task header */}
      <div className="relative flex flex-row justify-between">
        <div className="flex items-center">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-100 dark:bg-indigo-100 dark:bg-white/5">
            <MdCheckCircle className="h-6 w-6 text-brand-500 dark:text-white" />
          </div>
          <h4 className="ml-4 text-xl font-bold text-navy-700 dark:text-white">
            「AI Help ME」
          </h4>
        </div>
        <CardMenu />
      </div>

      {/* task content */}

      <div className="h-full w-full">
        <div className="mt-5 flex items-center justify-between p-2">
          <div className="flex items-center justify-center gap-2">
            <Checkbox />
            <p className="text-base font-bold text-navy-700 dark:text-white">
              Meta AI
            </p>
          </div>
          <div>
            <MdDragIndicator className="h-6 w-6 text-navy-700 dark:text-white" />
          </div>
        </div>

        <div className="mt-2 flex items-center justify-between p-2">
          <div className="flex items-center justify-center gap-2">
            <Checkbox />
            <p className="text-base font-bold text-navy-700 dark:text-white">
              Got AI
            </p>
          </div>
          <div>
            <MdDragIndicator className="h-6 w-6 text-navy-700 dark:text-white" />
          </div>
        </div>

        <div className="mt-2 flex items-center justify-between p-2">
          <div className="flex items-center justify-center gap-2">
            <Checkbox />
            <p className="text-base font-bold text-navy-700 dark:text-white">
              Openai AI
            </p>
          </div>
          <div>
            <MdDragIndicator className="h-6 w-6 text-navy-700 dark:text-white" />
          </div>
        </div>

        <div className="mt-2 flex items-center justify-between p-2">
          <div className="flex items-center justify-center gap-2">
            <Checkbox />
            <p className="text-base font-bold text-navy-700 dark:text-white">
              Microsoft AI
            </p>
          </div>
          <div>
            <MdDragIndicator className="h-6 w-6 text-navy-700 dark:text-white" />
          </div>
        </div>
      </div>

      <div className="flex mb-4 justify-center mt-4">
        <a href="https://www.chatgpt.com" target="_blank" rel="noopener noreferrer" className="mr-4">
          <img src="https://img.shields.io/badge/GPT%20AI-blue?style=social&logo=openai" alt="GPT AI" />
        </a>
        <a href="https://www.meta.ai" target="_blank" rel="noopener noreferrer" className="mr-4">
          <img src="https://img.shields.io/badge/Meta%20AI-blue?style=social&logo=meta" alt="Meta AI" />
        </a>
        <a href="https://openai.com" target="_blank" rel="noopener noreferrer" className="mr-4">
          <img src="https://img.shields.io/badge/Open%20AI-blue?style=social&logo=openai" alt="Open AI" />
        </a>
        <a href="https://www.microsoft.com/en-us/ai" target="_blank" rel="noopener noreferrer" className="mr-4">
          <img src="https://img.shields.io/badge/Microsoft%20AI-blue?style=social&logo=microsoft" alt="Microsoft AI" />
        </a>
      </div>
    </Card>
  );
};

export default TaskCard;


